module.exports = __webpack_public_path__ + "img/card3.fb218b17.png";